import React, { useState, useEffect } from "react";
import CheckListSharedProcessForm from "../../../check_list/shared_process/form";
import { share as shareCheckListProcess } from '../agreement_process/axios';
import _ from "lodash-es";

const CoerporateCheckListSharedProcessForm = props => {
  const [sharedProcesses, setSharedProcesses] = useState(props?.sharedProcesses || [])
  const { checkListProcess, currentUser } = props;

  return (
    < >
      <CheckListSharedProcessForm
        checkListProcess={checkListProcess}
        currentUser={currentUser}
        sharedProcesses={sharedProcesses}
        callbackSharedProcesses={setSharedProcesses}
        context={"corporate"}
        actions={{
          shareCheckListProcess: shareCheckListProcess,
          showCheckListProcessPath: Routes.corporate_check_list_agreement_process_path
        }}
      />
    </>
  )
}

export default CoerporateCheckListSharedProcessForm;
